// Debe mantenerse igual al mapeo de Backend/src/lib/pagePermissions.ts
// y a `predefinedRoleCards` en ConfigUsersSection.vue.

export const PAGE_KEYS = [
  'dashboard', 'contratos', 'finanzas', 'mantenimiento', 'servicios', 'cobranza', 'configuracion',
  'portalTecnicos', 'portalInquilinos',
]

const ROLE_PAGES = {
  ADMIN: ['dashboard', 'contratos', 'finanzas', 'mantenimiento', 'servicios', 'cobranza', 'configuracion', 'portalTecnicos', 'portalInquilinos'],
  OPERATIONS: ['dashboard', 'contratos', 'mantenimiento', 'servicios'],
  FINANCE: ['dashboard', 'finanzas', 'cobranza'],
  MAINTENANCE_SUPERVISOR: ['dashboard', 'mantenimiento'],
  // Por ahora el técnico solo tiene Cuenta (su portal de tickets aún no existe).
  TECHNICIAN: ['portalTecnicos'],
}

export function userHasPageAccess(user, pageKey) {
  if (!user) return false
  if (user.role === 'CUSTOM') {
    const perms = user.customRole?.permissions || {}
    return !!perms?.[pageKey]?.view
  }
  const pages = ROLE_PAGES[user.role] || []
  return pages.includes(pageKey)
}